'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import { navCssClassNames } from './navCssClassNames';
import clsx from 'clsx';
const Wrapper = styled('div')(({ theme }) => `
    display: grid;
    grid-template-columns: ${theme.tokens.FuelSpacing6} auto ${theme.tokens.FuelSpacing6}; // to balance the text
    align-items: center;
    gap: ${theme.tokens.FuelSpacing1};

    position: sticky;
    z-index: 1;
    top: 0;
    height: 3rem;

    background: white;
    padding-inline: ${theme.tokens.FuelSpacing4};
    border-bottom: solid 1px ${theme.tokens.FuelColorBorderLight};
    text-align: center;
`);
const Title = styled('div')(({ theme }) => `
    color: ${theme.tokens.FuelColorTextSecondary};

    width: 100%;
    font-weight: ${theme.tokens.FuelFontWeightSemibold};
    font-size: ${theme.tokens.FuelFontSizeBase};
    line-height: ${theme.tokens.FuelLineHeightBase};

    padding-inline: ${theme.tokens.FuelSpacing2};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`);
const BackButton = styled(IconButton)(({ theme }) => `
    height: ${theme.tokens.FuelSpacing6};
    width: ${theme.tokens.FuelSpacing6};
`);
export const NavDrawerHeader = (props) => (_jsxs(Wrapper, { className: clsx(props.className, navCssClassNames.drawerHeader), children: [_jsx(BackButton, { "aria-label": 'back', onClick: props.onBackClick, size: 'small', children: _jsx(KeyboardArrowLeft, {}) }), _jsx(Title, { className: clsx(navCssClassNames.drawerHeaderText, 'FuelStyledMenuHeader-text'), children: props.children })] }));
